import { RouterProvider, createBrowserRouter } from "react-router-dom";
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { auth } from "./firebase";
import ProtectedRoute from "./component/protected-route";
import Layout from "./component/layout";
import LoadingScreen from "./component/loading-screen";
import Login from "./routes/login";
import Profile from "./routes/profile";
import CreateAccount from "./routes/create-account";
import Posting from "./component/posting";
import Developer from "./component/developer";
import './App.css';
import Timeline from "./component/timeline";
import LikeNotifications from "./component/LikeNotifications";

const Wrapper = styled.div``;

const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        path: "",
        element: <Timeline/>,
      },
      {
        path: "alert",
        element: <LikeNotifications />,
      },
      {
        path: "profile/:userId",
        element: <Profile />,
      },
      {
        path: "posting",
        element: <Posting />,
      },
      {
        path: "developer",
        element: <Developer />,
      }
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/create-account",
    element: <CreateAccount />,
  },
]);

function App() {
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(() => {
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <Wrapper>
      {/* <LikeNotifications /> */}
      {isLoading ? <LoadingScreen /> : <RouterProvider router={router} />}
    </Wrapper>
  );
}

export default App;